module.exports = __webpack_public_path__ + "img/title-@2x.16163b33.png";